$(() => {

if (typeof window.ontouchstart != 'undefined') {
	$('body').addClass('touch-device');
} else {
	$('body').addClass('can-hover');
}

let origDesc = $('.colDescription p'),
    toggleDesc = $(".toggleDesc"),
    signUp= $(".colAlertSignup"),
    subUrl="//profreg." + getDomain('profreg') + "medscape.com/px/columns/";

$.ajax({
    type: "GET",
    url: `${subUrl}getallsubscriptions/2`,
    dataType: 'jsonp',
    success: function (data) {
        subscriptionStatus(data);
    }
});

toggleDesc.on("click", (ele)=>{
  let $this = $(ele.currentTarget);
  $this.parents("li.card").toggleClass("expanded");
  return false;
});

signUp.on("click", (ele)=>{
	if(loginStatus) {
		let $this = $(ele.currentTarget),
			action = $this.attr('data-action'),
			alertId=parseInt($this.attr('id').split("_")[1]);
			console.log(`${subUrl}${action}alert/2/${alertId}`);
			 $.ajax({
				type:"GET",
				url:`${subUrl}${action}alert/2/${alertId}`,
				dataType:'jsonp',
				success:function(data) {
					if(action=='add') {
						$("#card_"+alertId+" .actionState").text("Added");
						$("#card_"+alertId+" .actionStateAfter").text(" to");
						$("#card_"+alertId).addClass('subscribed');
						$this.attr('data-action', 'remove');
						wmdPageLink("alrt-clmn-subd");
						$this.off('mouseleave');
						$this.one('mouseleave', function() {
							$("#card_"+alertId+" .actionState").text("Remove");
							$("#card_"+alertId+" .actionStateAfter").text(" from");						
						});
					} else{
						$("#card_"+alertId+" .actionState").text("Removed");
						$("#card_"+alertId+" .actionStateAfter").text(" from");
						$("#card_"+alertId).removeClass('subscribed');
						$this.attr('data-action', 'add');
						wmdPageLink("alrt-clmn-unsub");
						$this.off('mouseleave');
						$this.one('mouseleave', function() {
							$("#card_"+alertId+" .actionState").text("Add");
							$("#card_"+alertId+" .actionStateAfter").text(" to");
						});
					}
				}
			});
	  return false;
	}
});

function subscriptionStatus(data){
	if(loginStatus) {
        signUp.each((i, ele) => {
            var alertId = parseInt(ele.id.split("_")[1]);
            if ($.inArray(alertId, data.subsciptionList) == -1) {
            	$(ele).attr('data-action', 'add');
                $("#card_"+alertId+" .actionState").text("Add");
                $("#card_"+alertId+" .actionStateAfter").text(" to");
            } else {
                // $(ele).attr('href', 'javascript:updateStatus(this,"' + alertId + '","remove");');
                $(ele).attr('data-action', 'remove');
                $(ele).addClass('added');
                $(ele).parents("li.card").addClass('subscribed');
                $("#card_"+alertId+" .actionState").text("Remove");
                $("#card_"+alertId+" .actionStateAfter").text(" from");
            }
        });
    } else {
        $(".colAlertSignup").attr("href",data.redirectUrl)
    }
}

function checkCardHeight() {
	if (breakpoint!=1) {
		origDesc.each((i, ele) => {
		  if (ele.scrollHeight > ele.offsetHeight) {
				$(ele).parents('.card:eq(0)').addClass('expandable');
			}
		});
	}
	else {
		$('.card.expanded').removeClass('expanded');
	}
}
checkCardHeight();
$(document).on("viewportChange",checkCardHeight);

});